import { Box, CircularProgress, Paper } from '@mui/material';
import Color from 'color';
import { Toggle } from '../../../../agencies/quotes/PrimeX/quoteDetails/components/Toggle';
import { StyledDivider } from './CoverageSummaryResolver/CoverageSummary/styles';
import { CoverageLegend } from './CoverageSummaryResolver/CoverageSummary/CoverageLegend';

const CoverageSummaryLoadingSkeleton = () => {
  return (
    <Paper elevation={4}>
      <Toggle
        toggleOn={false}
        handleToggle={() => null}
        label="Show All"
        style={{ position: 'absolute', top: 0, right: 15 }}
      />

      <CoverageLegend />

      <StyledDivider />

      <Box
        pt={5}
        pb={5}
        textAlign="center"
        sx={{
          backgroundColor: (theme) =>
            Color(theme.palette.background.active).lighten(0.045).toString(),
        }}
      >
        <CircularProgress size="5rem" />
      </Box>
    </Paper>
  );
};

export default CoverageSummaryLoadingSkeleton;
